module.exports = __webpack_public_path__ + "img/header-10.aa594961.png";